import ImageOne from '../images/portail1.webp'; 
import ImageTwo from '../images/portailautomatique.webp'; 
import ImageThree from '../images/portailenbois.webp'; 
import ImageFour from '../images/grillage.webp'; 



export const SliderData = [
  {
    title: 'Besoin d\u0027une clôture pour votre jardin ?',
    price: 'Nous sommes là !',
    path: '/about',
    label: 'Nos services',
    image: ImageOne, ImageTwo, 
    alt: 'portail'
  },
  {
    title: 'Besoin d\u0027une clôture pour votre jardin ?',
    price: 'Nous sommes là !',
    path: '/about',
    label: 'Nos services',
    image: ImageTwo,
    alt: 'portail'
  },
  {
    title: 'Besoin d\u0027une clôture pour votre jardin ?',
    price: 'Nous sommes là !',
    path: '/about',
    label: 'Nos services',
    image: ImageThree,
    alt: 'portail'
  },
  {
    title: 'Besoin d\u0027une clôture pour votre jardin ?',
    price: 'Nous sommes là !',
    path: '/about',
    label: 'Nos services',
    image: ImageFour,
    alt: 'portail'
  }
];